<div class="side-Navigation" [class.sidebar-locked]="!isSidebarInteractive">
  <div class="sidebar-brand d-flex align-items-center justify-content-center kc_logo">
    <div class="sidebar-brand-icon" *ngFor="let AllpracticesList of Allpractices; let i = index">
      <img class="img-responsive kc_logo cursor-pointer" src="{{ AllpracticesList.firmLogo }}"
        (load)="onFavoriteLogoLoad()" (error)="onFavoriteLogoError($event)" alt=" {{ AllpracticesList.firmName }}" loading="lazy"
        #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="invertebrates" *ngIf="AllpracticesList.favorite" />
    </div>
    <mat-menu #invertebrates="matMenu" [overlapTrigger]="false" class="select-practice-menu">
      <div (mouseleave)="closeSubMenu(menuTrigger)">
        <ul>
          <li *ngFor="let AllpracticesList of Allpractices; let i = index;">
            <button mat-button class="select-practice-item"
              [ngClass]="{'active-practice-name':AllpracticesList.favorite}"
              (click)="FavoriteChange(AllpracticesList.tenants,AllpracticesList.id,AllpracticesList.dbkey)">
              <span class="select-practice-item-logo">
                <img src="{{AllpracticesList.firmLogo}}" (error)="onImageError($event)" alt="icon" loading="lazy" />
              </span>
              <span class="select-practice-item-name">
                {{AllpracticesList.firmName}}
              </span>
            </button>
          </li>
        </ul>
        <div class="select-practice-menu-footer">
          <button mat-button class="cmn-inverse-btn" (click)="OpenDashboardPopup()">See more</button>
        </div>
      </div>
    </mat-menu>
  </div>
  <div class="sidebar-scroll">
    <ul class="navbar-nav bg-gradient-primary sidebar sidebar-dark accordion new_css_yop" id="accordionSidebar">
      <li id="dash" class="nav-item">
        <a class="nav-links" routerLink="/dashboard" routerLinkActive="link-active" (click)="onMenuNavigationClick($event, '/dashboard')">
          <span class="btn-inner--icon Dashboard"> </span>
          <span data-cy="dcyDashBoard" class="nav-links-text">Dashboard</span>
        </a>
      </li>
      
      <li data-cy="dcyClients" id="clients" class="nav-item" *ngIf="sclientlist">
        <a *ngIf="isClientFeature" class="nav-links" [routerLink]="'/client/clientlist'" routerLinkActive="link-active" (click)="onMenuNavigationClick($event, '/client/clientlist')"
          [routerLinkActiveOptions]="{ exact: true }" [ngClass]="{
            'link-active': isClientContactActive,
            'link-active-clientlist': isClientListActive
          }">
          <span class="btn-inner--icon Clients"></span>
          <span class="nav-links-text">Clients</span>
        </a>
      </li>
  
      <li data-cy="dcyClients" id="client-classic" class="nav-item" *ngIf="sclientlist">
        <a *ngIf="isClientFeature && isClientClassicFeature" class="nav-links" [routerLink]="'/client/client-classic'" routerLinkActive="link-active" (click)="onMenuNavigationClick($event, '/client/client-classic')"
          [routerLinkActiveOptions]="{ exact: true }" [ngClass]="{
            'link-active': isClientClassicActive,
            'link-active-clientlist': isClientClassicActive
          }">
          <span class="btn-inner--icon Clients"></span>
          <span class="nav-links-text">Clients Classic</span>
        </a>
      </li>
  
      <li data-cy="dcyWorkFlow" id="workflow" class="nav-item" *ngIf="sJobspriv">
        <a *ngIf="isFeature" class="nav-links" [routerLink]="'/job/joblist'" routerLinkActive="link-active" (click)="onMenuNavigationClick($event, '/job/joblist')"
          [routerLinkActiveOptions]="{ exact: true }" [ngClass]="{
            'link-active': isJobProfileActive,
            'link-active-joblist': isJobListActive
          }">
          <span class="btn-inner--icon Workflows"></span>
          <span class="nav-links-text">Workflows</span>
        </a>
      </li>
  
      <li data-cy="dcyPlanning" id="planning" class="nav-item" *ngIf="sPlanning">
        <a class="nav-links" routerLink="/planning/planninglist" routerLinkActive="link-active" (click)="onMenuNavigationClick($event, '/planning/planninglist')">
          <span class="btn-inner--icon Planning"> </span>
          <span class="nav-links-text">Planning</span>
        </a>
      </li>
      <li id="documentList" class="nav-item" *ngIf="sDocpriv">
        <a class="nav-links" routerLinkActive="link-active" (click)="onDocumentsTabClick($event)" [ngClass]="{
        'link-active': dmsAuth.isActive || dmsSite.isActive || dmsSites.isActive || document.isActive
        }">
          <span class="btn-inner--icon Documents"></span>
          <span class="nav-links-text">Documents</span>
        </a>
  
        <!-- Hidden links just for routerLinkActive tracking -->
        <a routerLink="/dms/auth" routerLinkActive #dmsAuth="routerLinkActive" style="display: none"></a>
        <a routerLink="/dms/site" routerLinkActive #dmsSite="routerLinkActive" style="display: none"></a>
        <a routerLink="/dms/sites" routerLinkActive #dmsSites="routerLinkActive" style="display: none"></a>
        <a routerLink="/document" routerLinkActive #document="routerLinkActive" style="display: none"></a>
      </li>
  
  
      <li data-cy="dcyTimeSheet" id="timesheet" class="nav-item" *ngIf="aTimesheet || uTimesheet">
        <a *ngIf="isTimeSheetFeature" class="nav-links" [routerLink]="_timesheeturl" routerLinkActive="link-active" (click)="onMenuNavigationClick($event, _timesheeturl)">
          <span class="btn-inner--icon Timesheets"> </span>
          <span class="nav-links-text">Timesheets</span>
        </a>
      </li>
  
      <li id="Billing" class="nav-item billing-menu" *ngIf="sBilling || sWIPView"
        [class.shortcut-open]="isBillingShortcutOpen" [class.billing-open-up]="isBillingFlyoutUpward"
        (mouseenter)="onBillingMenuMouseEnter($event)" (mouseleave)="onBillingMenuMouseLeave()">
        <a class="nav-links" [ngClass]="{ 'link-active': isBillingSectionActive() }" routerLink="/billing/billings" [class.link-active]="isBillingActive()" (click)="onBillingNavigationClick($event, '/billing/billings', 'billing')">
          <span class="btn-inner--icon Billing"> </span>
          <span class="nav-links-text">Billing<i class="shortcut-hint" *ngIf="showShortcutHints">B</i></span>
        </a>
        <ul [ngStyle]="billingFlyoutStyle" (mouseenter)="onBillingSubmenuMouseEnter($event)" (mouseleave)="onBillingSubmenuMouseLeave($event)">
          <li><a routerLink="/billing/billings" [class.link-active]="isBillingSubItemActive('wip')" (click)="onBillingNavigationClick($event, '/billing/billings', 'billing')">WIP<i class="show-shortcut-hint">W</i></a></li>
          <li><a routerLink="/billing/invoices" [class.link-active]="isBillingSubItemActive('invoicing')" (click)="onBillingNavigationClick($event, '/billing/invoices', 'billing')">Invoices<i class="show-shortcut-hint">I</i></a></li>
          <li><a routerLink="/billing/planned-invoices" [class.link-active]="isBillingSubItemActive('planned')" (click)="onBillingNavigationClick($event, '/billing/planned-invoices', 'billing')">Planned Invoices<i class="show-shortcut-hint">L</i></a></li>
          <li *ngIf="isBillingPaymentEnabled">
            <a [class.link-active]="isBillingSubItemActive('payments')">Payment  <img src="../../../assets/img/Breadcrumb.svg" /><i class="show-shortcut-hint">P</i></a>
            <ul [class.shortcut-open]="isPaymentShortcutOpen">
              <li><a routerLink="/billing/payments/bank-statements" [class.link-active]="isBillingSubItemActive('bankStatements')" (click)="onBillingNavigationClick($event, '/billing/payments/bank-statements', 'billing')">Bank statement<i class="show-shortcut-hint">S</i></a></li>
              <li><a routerLink="/billing/payments/reconcile" [class.link-active]="isBillingSubItemActive('reconcile')" (click)="onBillingNavigationClick($event, '/billing/payments/reconcile', 'billing')">Reconcile<i class="show-shortcut-hint">R</i></a></li>
            </ul>
          </li>
        </ul>
      </li>
      <li id="BillingBeta" class="nav-item billingbeta-menu" *ngIf="isBillingBetaFeature" [class.beta-shortcut-open]="isBillingBetaShortcutOpen" [class.billing-beta-open-up]="isBillingBetaFlyoutUpward" (mouseenter)="onBillingBetaMenuMouseEnter($event)" (mouseleave)="onBillingBetaMenuMouseLeave()">
        <a class="nav-links" routerLink="/billing/billing-details" [class.link-active]="isBillingBetaActive()" (click)="onBillingNavigationClick($event, '/billing/billing-details', 'beta')">
          <span class="btn-inner--icon Billing"> </span>
          <span class="nav-links-text">Billing Beta</span>
        </a>
        <ul [ngStyle]="billingBetaFlyoutStyle" (mouseenter)="onBillingBetaSubmenuMouseEnter($event)" (mouseleave)="onBillingBetaSubmenuMouseLeave($event)">
          <li><a routerLink="/billing/billing-details" [class.link-active]="isBillingSubItemActive('wip', 'beta')" (click)="onBillingNavigationClick($event, '/billing/billing-details', 'beta')">WIP</a></li>
          <li><a routerLink="/billing/billing-details/invoices" [class.link-active]="isBillingSubItemActive('invoicing', 'beta')" (click)="onBillingNavigationClick($event, '/billing/billing-details/invoices', 'beta')">Invoices</a></li>
          <li><a routerLink="/billing/billing-details/planned-invoices" [class.link-active]="isBillingSubItemActive('planned', 'beta')" (click)="onBillingNavigationClick($event, '/billing/billing-details/planned-invoices', 'beta')">Planned Invoices</a></li>
          <li *ngIf="isBillingPaymentEnabled">
            <a [class.link-active]="isBillingSubItemActive('payments', 'beta')">Payment  <img src="../../../assets/img/Breadcrumb.svg" /></a>
            <ul [class.shortcut-open]="isPaymentShortcutOpen">
              <li><a routerLink="/billing/billing-details/payments/bank-statements" [class.link-active]="isBillingSubItemActive('bankStatements', 'beta')" (click)="onBillingNavigationClick($event, '/billing/billing-details/payments/bank-statements', 'beta')">Bank statement</a></li>
              <li><a routerLink="/billing/billing-details/payments/reconcile" [class.link-active]="isBillingSubItemActive('reconcile', 'beta')" (click)="onBillingNavigationClick($event, '/billing/billing-details/payments/reconcile', 'beta')">Reconcile</a></li>
            </ul>
          </li>
        </ul>
      </li>
      <li data-cy="dcyReporting" id="Reporting" class="nav-item" *ngIf="sReporting">
        <a class="nav-links" routerLink="/reports/wipreport" routerLinkActive="link-active" (click)="onMenuNavigationClick($event, '/reports/wipreport')">
          <span class="btn-inner--icon Reporting"> </span>
          <span class="nav-links-text">Reporting</span>
        </a> 
      </li>
      <li data-cy="dcySettings" id="setting" class="nav-item" *ngIf="sSettings">
        <a *ngIf="isSettingFeature" class="nav-links" [routerLink]="'/settings/connections'" (click)="onMenuNavigationClick($event, '/settings/connections')"
          routerLinkActive="link-active" [ngClass]="{
            'link-active-submenu': settingdivison.isActive,
            'link-active-submenuone': firmdetails.isActive,
            'link-active-submenutwo': disbursement.isActive,
            'link-active-submenuthree': customfields.isActive,
            'link-active-submenufour': jobworkflow.isActive,
            'link-active-submenufive': tagsettings.isActive,
            'link-active-submenusix': template.isActive,
            'link-active-submenuseven': timesheet.isActive,
            'link-active-submenusTeams': Teams.isActive,
            'link-active-submenustaxagent': taxagent.isActive,
            'link-active-submenususers': users.isActive,
            'link-active-submenuspermission': permission.isActive,
            'link-active-submenusbulkupdate': bulkupdate.isActive,
            'link-active-submenuswipcontrol': wipcontrol.isActive,
            'link-active-Templatedashboard': Templatedashboard.isActive,
            'link-active-dataintegrationdetails': dataintegrationdetails.isActive,
            'link-active-office': office.isActive,
            'link-active-staffbudget': staffbudget.isActive,
            'link-active-connections': connections.isActive,
            'link-active-bulkUpdateDisbursements': bulkUpdateDisbursements.isActive,
            'link-active-bulkUpdateInvoicePreview': bulkUpdateInvoicePreview.isActive,
            'link-active-sendInvoiceView': sendInvoiceView.isActive
          }">
          <span class="btn-inner--icon Settings"> </span>
          <span class="nav-links-text">Settings</span>
        </a>
        <a routerLink="/settings/connections" routerLinkActive #connections="routerLinkActive" class="tabs-overflow-menu"
          style="display: none"></a>
        <a routerLink="/settings/divisionmanagement" routerLinkActive #settingdivison="routerLinkActive"
          class="tabs-overflow-menu" style="display: none"></a>
        <a routerLink="/settings/disbursement" routerLinkActive #disbursement="routerLinkActive"
          class="tabs-overflow-menu" style="display: none"></a>
        <a routerLink="/settings/firmdetails" routerLinkActive #firmdetails="routerLinkActive" class="tabs-overflow-menu"
          style="display: none"></a>
        <a routerLink="/settings/customfields" routerLinkActive #customfields="routerLinkActive"
          class="tabs-overflow-menu" style="display: none"></a>
        <a routerLink="/settings/jobworkflow" routerLinkActive #jobworkflow="routerLinkActive" class="tabs-overflow-menu"
          style="display: none"></a>
        <a routerLink="/settings/tagsettings" routerLinkActive #tagsettings="routerLinkActive" class="tabs-overflow-menu"
          style="display: none"></a>
        <a routerLink="/settings/template" routerLinkActive #template="routerLinkActive" class="tabs-overflow-menu"
          style="display: none"></a>
        <a routerLink="/settings/timesheet" routerLinkActive #timesheet="routerLinkActive" class="tabs-overflow-menu"
          style="display: none"></a>
        <a routerLink="/settings/teams" routerLinkActive #Teams="routerLinkActive" class="tabs-overflow-menu"
          style="display: none"></a>
        <a routerLink="/settings/taxagent" routerLinkActive #taxagent="routerLinkActive" class="tabs-overflow-menu"
          style="display: none"></a>
        <a routerLink="/settings/users" routerLinkActive #users="routerLinkActive" class="tabs-overflow-menu"
          style="display: none"></a>
        <a routerLink="/settings/permission" routerLinkActive #permission="routerLinkActive" class="tabs-overflow-menu"
          style="display: none"></a>
        <a routerLink="/settings/bulkupdate" routerLinkActive #bulkupdate="routerLinkActive" class="tabs-overflow-menu"
          style="display: none"></a>
        <a routerLink="/settings/wipcontrol" routerLinkActive #wipcontrol="routerLinkActive" class="tabs-overflow-menu"
          style="display: none"></a>
        <a routerLink="/settings/Templatedashboard" routerLinkActive #Templatedashboard="routerLinkActive"
          class="tabs-overflow-menu" style="display: none"></a>
        <a routerLink="/settings/data-integration-details" routerLinkActive #dataintegrationdetails="routerLinkActive"
          class="tabs-overflow-menu" style="display: none"></a>
        <a routerLink="/settings/office" routerLinkActive #office="routerLinkActive" class="tabs-overflow-menu"
          style="display: none"></a>
        <a routerLink="/settings/staff-budget" routerLinkActive #staffbudget="routerLinkActive" class="tabs-overflow-menu"
          style="display: none"></a>
        <a routerLink="/settings/bulkUpdateDisbursements" routerLinkActive #bulkUpdateDisbursements="routerLinkActive" class="tabs-overflow-menu"
        style="display: none"></a>
        <a routerLink="/settings/bulkUpdateInvoicePreview" routerLinkActive #bulkUpdateInvoicePreview="routerLinkActive" class="tabs-overflow-menu"
        style="display: none"></a>
        <a routerLink="/settings/sendInvoiceView" routerLinkActive #sendInvoiceView="routerLinkActive" class="tabs-overflow-menu"
        style="display: none"></a>
      </li>
      <li id="Billing" class="nav-item" *ngIf="false">
        <a *ngIf="isNewBillingFeature" class="nav-links" routerLink="/billing/billings" routerLinkActive="link-active" (click)="onMenuNavigationClick($event, '/billing/billings')">
          <span class="btn-inner--icon Billing"> </span>
          <span class="nav-links-text">Billing (Beta)</span>
        </a>
      </li>
    </ul>
  </div>
</div>

<!-- select practice popup -->
<ng-template #selectPracticePopup>
  <div class="select-practice-popup-container">
    <div class="cmn-modal-header">
      <h4 class="modal-header-title">
        Select practice
      </h4>
    </div>
    <div class="cmn-modal-content">
      <!-- Recent visit practices section-->
      <div class="select-practice-content-row">
        <h6 class="practice-row-title">Recent visit</h6>
        <div class="select-practice-items-row">
          <div class="select-practice-items-row-item"
            *ngFor="let RecentpracticesList of Recentpractices; let i = index;">
            <div class="select-practice-items-row-item-card">
              <div class="select-practice-items-row-item-card-left">
                <img src="{{RecentpracticesList.firmLogo}}" (error)="onImageError($event)" class="card-practice-logo"
                  alt="firmimage" loading="lazy" />
              </div>
              <div class="select-practice-items-row-item-card-right">
                <span class="star-action-link">
                  <img src="../../assets/img/DashboardIcons/Starblack.svg" *ngIf="!RecentpracticesList.favorite"
                    class="card-practice-staric"
                    (click)="FavoriteChange(RecentpracticesList.tenants,RecentpracticesList.id,RecentpracticesList.dbkey)"
                    alt="icon" loading="lazy" />
                  <img src="../../assets/img/DashboardIcons/StarYellow.svg" *ngIf="RecentpracticesList.favorite"
                    class="card-practice-staric"
                    (click)="FavoriteChange(RecentpracticesList.tenants,RecentpracticesList.id,RecentpracticesList.dbkey)"
                    alt="icon" loading="lazy" />
                </span>
                <h6 class="select-practice-name" [title]="RecentpracticesList.firmName">{{RecentpracticesList.firmName}}
                </h6>
                <p class="select-practice-loggedtext">
                  Last logged in<span class="practice-login-time">{{RecentpracticesList.lastLogin}}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Recent visit practices section end -->
      <!-- All practices section-->
      <div class="select-practice-content-row mt-4">
        <h6 class="practice-row-title">All practice</h6>
        <div class="select-practice-items-row">
          <div class="select-practice-items-row-item" *ngFor="let AllpracticesList of Allpractices; let i = index;">
            <div class="select-practice-items-row-item-card">
              <div class="select-practice-items-row-item-card-left">
                <img src="{{AllpracticesList.firmLogo}}" (error)="onImageError($event)" class="card-practice-logo"
                  alt="firmimage-icon" loading="lazy" />
              </div>
              <div class="select-practice-items-row-item-card-right">
                <span class="star-action-link">
                  <img src="../../assets/img/DashboardIcons/Starblack.svg" *ngIf="!AllpracticesList.favorite"
                    class="card-practice-staric"
                    (click)="FavoriteChange(AllpracticesList.tenants,AllpracticesList.id,AllpracticesList.dbkey)"
                    alt="icon" loading="lazy" />
                  <img src="../../assets/img/DashboardIcons/StarYellow.svg" *ngIf="AllpracticesList.favorite"
                    class="card-practice-staric"
                    (click)="FavoriteChange(AllpracticesList.tenants,AllpracticesList.id,AllpracticesList.dbkey)"
                    alt="icon" loading="lazy" />
                </span>
                <h6 class="select-practice-name" [title]="AllpracticesList.firmName">{{AllpracticesList.firmName}}</h6>
                <p class="select-practice-loggedtext" *ngIf="AllpracticesList?.lastLogin">
                  Last logged in<span class="practice-login-time">{{AllpracticesList.lastLogin}}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- All practices section end -->
    </div>
    <div class="cmn-modal-footer">
      <button class="cmn-inverse-btn" mat-button (click)="CloseDashboardPopup()">Cancel</button>
    </div>
  </div>
</ng-template>
<!-- select practice popup end-->
